import React from 'react';
export function ProblemSection() {
  return <section className="py-6 px-4 bg-red-50" data-id="element-166">
      <div className="max-w-4xl mx-auto" data-id="element-167">
        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-168">
          <h3 className="text-2xl md:text-4xl font-black text-gray-800 mb-3" data-id="element-169">
            ⚠️ Nadie nos enseñó sobre dinero…
          </h3>
          <p className="text-xl" data-id="element-170">
            Y sin darnos cuenta, estamos repitiendo lo mismo con nuestros hijos.
          </p>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-171">
          <h2 className="text-3xl md:text-5xl font-black text-red-600 mb-4" data-id="element-172">
            🚨 Si tu hijo…
          </h2>
          <ul className="space-y-2" data-id="element-173">
            <li className="flex items-start" data-id="element-174">
              <span className="text-red-600 font-bold mr-3" data-id="element-175">❌</span>
              <span className="text-lg" data-id="element-176">No sabe ahorrar</span>
            </li>
            <li className="flex items-start" data-id="element-177">
              <span className="text-red-600 font-bold mr-3" data-id="element-178">❌</span>
              <span className="text-lg" data-id="element-179">Gasta sin pensar</span>
            </li>
            <li className="flex items-start" data-id="element-180">
              <span className="text-red-600 font-bold mr-3" data-id="element-181">❌</span>
              <span className="text-lg" data-id="element-182">Te pide dinero constantemente</span>
            </li>
            <li className="flex items-start" data-id="element-183">
              <span className="text-red-600 font-bold mr-3" data-id="element-184">❌</span>
              <span className="text-lg" data-id="element-185">No entiende el valor de las cosas</span>
            </li>
          </ul>

          <div className="mt-4 p-4 bg-yellow-100 border-l-4 border-yellow-500" data-id="element-186">
            <p className="text-xl font-bold" data-id="element-187">👉 No es su culpa.</p>
            <p className="text-xl mt-1" data-id="element-188">
              Nadie le enseñó cómo manejar el dinero.
            </p>
          </div>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-lg" data-id="element-189">
          <h3 className="text-2xl md:text-4xl font-black text-red-600 mb-3" data-id="element-190">
            ⚠️ Y si no lo aprende ahora…
          </h3>
          <p className="text-xl mb-3" data-id="element-191">
            Lo va a aprender con errores cuando sea adulto.
          </p>
          <p className="text-xl mb-2" data-id="element-192">Errores como:</p>
          <ul className="space-y-2" data-id="element-193">
            <li className="flex items-start" data-id="element-194">
              <span className="text-red-600 font-bold mr-3" data-id="element-195">💸</span>
              <span className="text-lg" data-id="element-196">Deudas</span>
            </li>
            <li className="flex items-start" data-id="element-197">
              <span className="text-red-600 font-bold mr-3" data-id="element-198">💸</span>
              <span className="text-lg" data-id="element-199">Mala relación con el dinero</span>
            </li>
            <li className="flex items-start" data-id="element-200">
              <span className="text-red-600 font-bold mr-3" data-id="element-201">💸</span>
              <span className="text-lg" data-id="element-202">Estrés financiero</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}
export default ProblemSection;